import { matchPath, useLocation } from 'react-router-dom';

import { ROUTES } from 'configs/routes';
import { useDocumentScroll } from 'hooks/useDocumentScroll';
import { useHeaderVisibility } from 'hooks/useHeaderVisibility';
import { useRootStore } from 'stores/global/RootStore/context';

import { useSplitPageConfig } from './useSplitPageConfig';

const ACCREDITATION_EXEMPT_PATHS = [ROUTES.lk.profile.path, ROUTES.lk.lots.path];

type LkLayoutConfig = {
  shouldUseSplitPageLayout: boolean;
  shouldMergeHeaderAndContent: boolean;
  shouldShowHeader: boolean;
  shouldUseDocumentScroll: boolean;
  withHeaderBottomPadding: boolean;
  shouldShowAccreditationBanner: boolean;
};

export const useLkLayoutConfig = (): LkLayoutConfig => {
  const { pathname } = useLocation();
  const splitPage = useSplitPageConfig();
  const shouldShowHeader = useHeaderVisibility();
  const shouldUseDocumentScroll = useDocumentScroll();
  const { hasAccreditation } = useRootStore().userStore;

  const isAccreditationExemptPage =
    pathname === ROUTES.lk.path || ACCREDITATION_EXEMPT_PATHS.some((path) => matchPath({ path, end: false }, pathname));
  const shouldShowAccreditationBanner = !hasAccreditation && !isAccreditationExemptPage;

  return {
    shouldUseSplitPageLayout: splitPage.enabled,
    shouldMergeHeaderAndContent: splitPage.mergeHeaderAndContent && !shouldShowAccreditationBanner,
    shouldShowHeader,
    shouldUseDocumentScroll: shouldUseDocumentScroll && !splitPage.enabled,
    shouldShowAccreditationBanner,
    withHeaderBottomPadding: !splitPage.enabled && !shouldShowAccreditationBanner,
  };
};
